module.exports = __webpack_public_path__ + "static/media/plan.5ca3f270.png";